export enum HubspotITRAnswers {
  YES = 'Yes! I want to re-enroll my whole family. No changes.',
  YES_SOME = 'Yes, but only some of my family. I have some changes',
  YES_NEW = 'Yes, but I also have a new student to add.',
  NO = `No, we won't be coming back for the 25-26 school year.`,
}
